'use client';

import * as React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';

const navLinks = [
  { label: 'Features', href: '/features' },
  { label: 'Office', href: '/office' },
  { label: 'Security', href: '/security' },
  { label: 'Download', href: '/download' },
  { label: 'Pricing', href: '/pricing' },
];

export function MarketingNav() {
  const pathname = usePathname();
  const [scrolled, setScrolled] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,box-shadow] duration-200 ${
        scrolled
          ? 'bg-white shadow-[0_1px_0_#e5e5e5]'
          : 'bg-white'
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex items-center justify-between h-[56px]">
          <Link href="/" className="flex items-center gap-2 shrink-0">
            <Image
              src="/images/logo.png"
              alt="TekSpert Mail"
              width={130}
              height={32}
              className="h-[22px] w-auto object-contain"
              priority
            />
          </Link>

          {/* Desktop links */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.href}
                href={l.href}
                className={`px-3 py-1.5 text-[14px] rounded-sm transition-colors ${
                  pathname === l.href
                    ? 'text-[#0078D4] font-semibold'
                    : 'text-[#333] hover:text-[#0078D4]'
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              href="/auth/login"
              className="hidden sm:block text-[14px] text-[#333] hover:text-[#0078D4] px-3 py-1.5 transition-colors"
            >
              Sign in
            </Link>
            <Link
              href="/auth/register"
              className="text-[14px] font-semibold text-white bg-[#0078D4] hover:bg-[#005A9E] px-5 py-2 rounded-[4px] transition-colors"
            >
              Get started
            </Link>

            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden p-2 text-[#333] hover:text-[#0078D4]"
              aria-label="Menu"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-[#e5e5e5] bg-white px-6 py-3 space-y-1">
          {navLinks.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="block py-2 text-[14px] text-[#333] hover:text-[#0078D4]"
            >
              {l.label}
            </Link>
          ))}
          <Link
            href="/auth/login"
            onClick={() => setMenuOpen(false)}
            className="block py-2 text-[14px] text-[#0078D4] font-medium"
          >
            Sign in
          </Link>
        </div>
      )}
    </header>
  );
}
